import React, { useContext } from 'react'
import GiftContext from '../../../context/context'
import Field from '../../common/field'

function FormLogin({ onChangeForm }) {
  const { formContent, formData, handleChangeField, renderError } = useContext(GiftContext)

  const handleForgotPassword = () => {
    onChangeForm('passwordRecovery')
  }

  return (
    <div className="form-state --login">
      <div className="form-field field-email">
        <Field
          label={formContent.texts.email}
          name="email"
          type="text"
          value={formData.email}
          hasError={
            renderError('email') || renderError('email.notvalid') || renderError('email.exists')
          }
          onChange={handleChangeField}
        />
      </div>
      <div className="form-field field-password">
        <Field
          label={formContent.texts.password}
          name="password"
          type="password"
          value={formData.password}
          hasError={renderError('password')}
          onChange={handleChangeField}
        />
      </div>
      <button type="button" className="recovery-buttom mb-3" onClick={handleForgotPassword}>
        {formContent.texts.forgotPassword}
      </button>
    </div>
  )
}

export default FormLogin
